import { Box, Typography } from "@material-ui/core";
import React from "react";
function TabPanel(props:any) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  export default TabPanel


// WEBPACK FOOTER //
// ./src/shared/components/TabView/TabPanel.tsx